import { createStore, applyMiddleware } from 'redux'
import { apiMiddleware } from 'redux-api-middleware'
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly'
import thunk from 'redux-thunk'
import logger from 'redux-logger'

const isDevEnv = process.env.NODE_ENV === 'development'
// eslint-disable-next-line no-underscore-dangle
const isReduxDevToolsInstalled = window && window.__REDUX_DEVTOOLS_EXTENSION__

const getMiddlewares = middlewares => {
  const allMiddlewares = [...middlewares, thunk, apiMiddleware]
  if (isDevEnv && !isReduxDevToolsInstalled) {
    allMiddlewares.push(logger)
  }
  return applyMiddleware(...allMiddlewares)
}

export default ({ reducer, middlewares = [] }) => {
  const composeEnhancers = composeWithDevTools({ trace: true, traceLimit: 25, serialize: true })
  return createStore(reducer, {}, composeEnhancers(getMiddlewares(middlewares)))
}
